/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useDeleteCoverage
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for delete coverage
 *
 */
interface IProps {
	coverageId: string;
	versionId?: string;
}
const useDeleteCoverage = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ coverageId, versionId }) => {
			await api.FHIRCoverageApi.deleteCoverage({ coverageId, versionId });
		},
		onSuccess: () => {
			setTimeout(() => {
				queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.insurances] });
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteCoverage;
